import React from 'react';

import FreeTextFilter from 'components/ReactTable/Filters/FreeTextFilter';
import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';
import WorkflowStageFilter from 'components/ReactTable/Filters/WorkflowStageFilter';
import DateRangeFilter from 'components/ReactTable/Filters/DateRangeFilter';
import NumberRangeFilter from 'components/ReactTable/Filters/NumberRangeFilter';

const CicColumnDefinitions = (permissions, workflowTab) => [
  {
    Header: 'Reference',
    accessor: 'referenceCode',
    Filter: FreeTextFilter,
    className: 'col-7p5'
  },
  {
    Header: 'Shareholder',
    accessor: 'customerName',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<CustomerLinkCell dataKey="customerDbId" data={ original } permissions={ permissions } />);
    },
    className: 'col-10p'
  },
  {
    Header: 'Action Required',
    accessor: 'cicActionRequired',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-12p5 text-centre'
  },
  {
    Header: 'Date Raised',
    accessor: 'createdDate',
    Filter: DateRangeFilter,
    className: 'col-7p5 text-centre'
  },
  {
    Header: 'Days Left for Review',
    accessor: 'daysToExpiration',
    Filter: NumberRangeFilter,
    className: 'col-12p5 text-centre'
  },
  {
    Header: 'Data Points',
    accessor: 'cicDataPoints',
    Filter: MultiSelectFilter,
    disableSortBy: true,
    className: ((workflowTab === 'complete') ? 'col-20p text-centre' : 'col-30p text-centre')
  },
  {
    Header: 'Workflow',
    accessor: 'workflowStatus',
    Filter: WorkflowStageFilter,
    disableFilters: (workflowTab !== 'resolvedCicAlerts' && workflowTab !== 'openCicAlerts' && workflowTab !== 'myalerts'),
    disableSortBy: (workflowTab !== 'resolvedCicAlerts' && workflowTab !== 'openCicAlerts' && workflowTab !== 'myalerts'),
    className: 'col-7p5 text-centre'
  },
  {
    Header: 'Closure Reason',
    accessor: 'closureReasonDesc',
    isVisible: (workflowTab === 'complete'),
    Filter: MultiSelectFilter,
    className: 'col-10p text-centre'
  },
  {
    Header: 'Assigned To',
    accessor: 'workflowUsername',
    disableFilters: (workflowTab === 'myalerts'),
    disableSortBy: true,
    className: 'col-10p'
  },
  {
    Header: 'Item Id',
    accessor: 'itemId',
    isVisible: false
  }
];

export default CicColumnDefinitions;
